import pluralize from 'pluralize'
import { FieldDefinition, SchemaResponse } from './client'
import {
  getDefinerForResource,
  getResourcesFromJunctionFields,
  getSearchFieldsForResource,
} from './mappings'

export const transformFieldListToObjectMap = (
  fieldDefinitions: FieldDefinition[],
) => {
  return fieldDefinitions.reduce(
    (acc, fieldDef) => {
      acc[fieldDef.name] = fieldDef
      return acc
    },
    {} as { [objectName: string]: FieldDefinition },
  )
}

export const pickValidFieldsFromIntrospectionQuery = (
  allowedSchemas: SchemaResponse[],
  schemaTypes: FieldDefinition[],
) => {
  const allowedSchemaNames = new Set(
    allowedSchemas.map((schema) => schema.name),
  )
  return schemaTypes.filter((fieldDefinition) => {
    return (
      fieldDefinition.kind === 'OBJECT' &&
      allowedSchemaNames.has(fieldDefinition.name)
    )
  })
}

export const addExtraFieldsToFieldDefinitions = (
  fieldDefinitions: FieldDefinition[],
) => {
  return fieldDefinitions.map((fieldDefinition) => {
    const fieldDefinitionName = fieldDefinition.name
    const resourcesFromJunctionFields =
      getResourcesFromJunctionFields(fieldDefinitionName)
    const searchFields = resourcesFromJunctionFields
      ? (resourcesFromJunctionFields
          .map((resource) => {
            const fieldDefinitionForResource = fieldDefinitions.find(
              (def) => def.name === resource,
            )
            return fieldDefinitionForResource
              ? `${pluralize.singular(resource)}.${getDefinerForResource(
                  fieldDefinitionForResource,
                )}`
              : null
          })
          .filter((val) => val !== null) as string[]) // Later versions of Typescript can remove this cast
      : getSearchFieldsForResource(fieldDefinition)

    return {
      name: fieldDefinitionName,
      fields: (fieldDefinition?.fields ?? []).map((field) => ({
        name: field.name,
        type: field.type,
      })),
      definer: getDefinerForResource(fieldDefinition),
      searchByFields: searchFields,
    }
  })
}
